// extracted by mini-css-extract-plugin
export default {"wrapperPadding":"ProductionBeatConfig_wrapperPadding__TOq0C","wordStyle":"ProductionBeatConfig_wordStyle__G6-55"};